import { makeHttpRequest } from "@/shared";

import { mapCalculatedSellingFromServer } from "./mappers/mapCalculatedSellingFromServer";
import { mapPaymentSellingToServer } from "./mappers/mapPaymentSellingToServer";

export const addPaymentToSelling = async (sessionKey, payment) => {
    const response = (
        await makeHttpRequest({
            url: `/stock/builder/${sessionKey}/add/payment`,
            method: "PUT",
            data: mapPaymentSellingToServer(payment),
        })
    ).data;

    return mapCalculatedSellingFromServer(response.data);
};
